import { LinkProps } from "next/link"
import styled from "styled-components"

import { ButtonStyle, StyledBySize } from "~/consts/button-style"

import Link from "./Link"

interface Props {
  children: string | React.ReactNode
  href: LinkProps["href"]
  size: "Medium" | "Small"
  target?: string
  disabled?: boolean
  className?: string
  variant?: "contained" | "outlined"
}

const CtaLink = ({ children, href, size, target, disabled, className, variant = "contained" }: Props) => {
  return (
    <StyledCtaLink
      href={href}
      styledBySize={StyledBySize[size]}
      target={target}
      disabled={Boolean(disabled)}
      className={className}
      variant={variant}
    >
      {children}
    </StyledCtaLink>
  )
}

const StyledCtaLink = styled(Link)`
  ${ButtonStyle}
`

export default CtaLink
